import { Browser } from "@capacitor/browser";
import { isNativePlatform } from "./platform";

export async function openExternalUrl(url: string): Promise<void> {
  if (typeof window === "undefined") {
    return;
  }

  if (isNativePlatform()) {
    await Browser.open({ url, presentationStyle: "popover" });
    return;
  }

  window.open(url, "_blank", "noopener,noreferrer");
}

export async function openTelLink(phoneNumber: string): Promise<void> {
  await openExternalUrl(`tel:${phoneNumber.replace(/\s+/g, "")}`);
}

export async function openMailtoLink(email: string): Promise<void> {
  await openExternalUrl(`mailto:${email}`);
}
